<template>
  <div>
    <loading-main v-if="loading"></loading-main>
    <div v-else class="dashboard-container">
      <sidebar
        :sidebar-dashboard="true"
        class="dashboard-container__sidebar"
      ></sidebar>
      <sidebar-mobile
        class="dashboard-container__sidebar-mobile"
      ></sidebar-mobile>
      <dashboard-creator-name
        class="dashboard-container__creator-name"
      ></dashboard-creator-name>
      <my-creations class="dashboard-container__my-creations"></my-creations>
      <owned-blueprints
        class="dashboard-container__my-favorites"
      ></owned-blueprints>
      <more-from-creators-club
        class="dashboard-container__more-from-creators-club"
      ></more-from-creators-club>
      <look-for-more-details
        class="dashboard-container__look-for-more-details"
      ></look-for-more-details>
      <!-- <FAQ class="dashboard-container__faq"></FAQ> -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
Vue.use(VueAwesomeSwiper);
import 'swiper/css/swiper.css';

import Sidebar from '@/components/sidebar/index';
import SidebarMobile from '@/components/sidebar_mobile/index';
import DashboardCreatorName from '@/components/dashboard/sections/DashboardCreatorName';
import MyCreations from '@/components/dashboard/sections/MyCreations';
import OwnedBlueprints from '@/components/dashboard/sections/OwnedBlueprints';
import LoadingMain from '@/components/common/loading/LoadingMain';

import * as wpApiCodes from '@/lib/webpayApiCodes.js';
import {
  addErrorNotification,
  addSuccesNotification,
} from '@/lib/notifications';

import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Dashboard',
  components: {
    LoadingMain,
    Sidebar,
    SidebarMobile,
    DashboardCreatorName,
    MyCreations,
    OwnedBlueprints,
    MoreFromCreatorsClub: () =>
      import('@/components/dashboard/sections/MoreFromCreatorsClub'),
    LookForMoreDetails: () =>
      import('@/components/dashboard/sections/LookForMoreDetails'),
    FAQ: () => import('@/components/faq/index'),
  },
  computed: {
    ...mapGetters('assets', { loading: 'loading' }),
  },
  created: function() {
    this.myCreationsAssets();
  },
  methods: {
    ...mapActions('all_assets', ['myCreationsAssets']),
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.result) {
      let result = to.query.result;
      switch (result) {
        case wpApiCodes.PAYMENT_SUCCESSFUL:
          addSuccesNotification('Succesfully paid');
          break;

        case wpApiCodes.PAYMENT_CANCELED_BY_USER:
          addSuccesNotification('Cancelled by user');

          break;
        case wpApiCodes.PAYMENT_DECLINED:
          addErrorNotification('Payment declined');
          break;
        case wpApiCodes.PAYMENT_EXPIRED_CARD:
          addErrorNotification('Expired card');
          break;
        case wpApiCodes.PAYMENT_EXPIRED:
          addErrorNotification('Payment expired');
          break;
        case wpApiCodes.TECHNICAL_PROBLEM:
          addErrorNotification('Technical problem, please try again later');
          break;
        default:
          break;
      }
      next();
    } else {
      next();
    }
  },
};
</script>

<style scoped lang="scss">
.dashboard-container {
  @include main-grid-container;

  &__sidebar {
    grid-column: col-start / span 3;
    grid-row: auto;
  }
  &__sidebar-mobile {
    grid-column: col-start / span 13;
    grid-row: auto;
  }
  &__creator-name {
    grid-column: col-start 4 / 13;
    grid-row: 1;
    position: relative;
    @media (max-width: $md-up) {
      .dashboard-container__creator-name {
        display: none;
      }
    }
  }
  &__my-creations {
    margin-top: -800px;
    position: relative;
    grid-column: col-start 4 / 13;
    grid-row: 2;
    background: $white-main;
    overflow: hidden;
    @media (max-width: $lg-up) {
      grid-column: col-start / 13;
      margin-top: 0;
      height: 500px;
    }
    //@media (max-width: $xm-up) {
    //    margin-top: 2rem;
    //}
    @media (max-width: $sm-up - 1px) {
      margin-top: 3rem;
      height: 400px;
    }
    @media (max-width: $xs-up) {
      grid-row: auto;
    }
  }
  &__my-favorites {
    margin-top: -300px;
    grid-column: col-start 4 / 13;
    grid-row: 3;
    background: $white-main;
    height: $small-height;
    overflow: hidden;
    //@media (max-width: $lg-up) {
    //    grid-column: col-start / 13;
    //    margin-top: 300px;
    //}
    @media (max-width: $lg-up) {
      grid-column: col-start / 13;
      grid-row: auto;
      margin-top: 0;
    }
    @media (max-width: $xs-up) {
      //grid-row: auto;
      //margin-top: 0;
      height: 500px;
    }
  }
  &__more-from-creators-club {
    grid-column: col-start 4 / 13;
    grid-row: 4;
    background: $blue-main;
    height: $very-small-height;
    @media (max-width: $xl-up) {
      height: $very-small-height;
    }
    @media (max-width: $lg-up) {
      grid-column: col-start / 13;
      margin-top: 0;
      height: $very-small-height;
    }
  }
  &__look-for-more-details {
    grid-column: col-start 4 / 13;
    grid-row: 5;
    height: $smallest-height;
    overflow: hidden;
    @media (max-width: $lg-up) {
      grid-column: col-start / 13;
      margin-top: 0;
    }
    @media (max-width: $xm-up) {
      height: $smallest-height;
    }
    @media (min-width: $xs-up) and (max-width: $sm-up) {
      height: $small-height;
    }
    @media (min-width: $xxs-up) and (max-width: $xs-up) {
      height: $small-height;
    }
  }
  &__faq {
    grid-column: col-start 4 / 13;
    grid-row: 6;
    height: auto;
    overflow: hidden;
    @media (max-width: $lg-up) {
      grid-column: col-start / 13;
      margin-top: 0;
    }
  }
}
</style>
